import React from 'react';
import { ReactComponent as ConturaLogo } from '../../../images/contura-logo.svg'
import ToggleMobileMenu from '../../components/Header/toggle-mobile-menu';
import NavigationList from '../../components/Navigation/navigation-list';
import { Link } from 'react-router-dom';

export default function Navigation({ baseName, newConstruction, unauthenticated }) {
    return (
        <div className="navigation">
            <div className="navigation-content">
                <div className="navigation-header">
                    <Link to="/home" className="navigation-logo">
                        <ConturaLogo />
                    </Link>
                    {(newConstruction || unauthenticated) && <Link className="navigation-login-btn" to="/home">Logga in</Link>}
                    <ToggleMobileMenu />
                </div>
                <NavigationList baseName={baseName} unauthenticated={unauthenticated} newConstruction={newConstruction} />
            </div>
        </div>
    );
}
